// Module
var code = `<div id="editorFooter" class="d-flex justify-content-between mt-2"> <span id="cursorPosition" class="cursor-position-text"></span> <span id="wordsCount" class="words-text"></span> </div>`;
// Exports
export default code;